// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/bundle." + chunkId + ".min.js?" + "0133557db52a72f86bfe" + "";
};